import { useMutation, useQueryClient } from "@tanstack/react-query";
import { globalConfigServices } from "features/globalConfiguration/services/globalConfig.service";
import toast from "react-hot-toast";

export const useUpdateGlobalConfig = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: globalConfigServices.updateGlobalConfig,
    onSuccess: () => {
      queryClient.invalidateQueries(["globalConfig"]);
      toast.success("Global configuration updated successfully");
    },
    onError: (error) => {
      const msg =
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Failed to update global configuration";
      toast.error(msg);
    },
  });
};